<template>
  <div class="widget-phone cc-mat-50">

    <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css"
    />

    <div v-if="this.calls.length > 0">
      <div class="state-WARNING animate__animated animate__flash animate__infinite">
        <div class="title cc-txt-center">
                    <span class="fa-stack fa-2x">
                        <i class="fas fa-circle fa-stack-2x"></i>
                        <i class="fas fa-phone fa-stack-1x"></i>
                    </span>
          <h1>QUELQU'UN EST AU TELEPHONE, chhh</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Phone',
  data() {
    return {
      calls: [],
    }
  },
  methods: {
    fetchData() {
      axios.get('https://api.alpixel.fr/telephony/status').then(response => {
        this.calls = response.data.data;
      });
    },
  },
  created() {
    this.fetchData();
    setInterval(() => this.fetchData(), 10 * 1000);
  }
}
</script>

<style scoped lang="less">
@green: #65e84f;
@orange: orange;
@red: red;

.widget-phone {
  display: flex;
  flex-wrap: wrap;

  & > div {
    flex: 0 0 100%;
    margin: 20px 0;

    & > div {
      padding: 20px;
    }

    &.tout-va-bien-navette {
      flex: 0 0 100%;
    }
  }

  .state {
    &-WARNING {
      background: @orange;
      color: #fff;

      .fa-circle {
        color: darken(@orange, 10%);
      }
    }

    &-DOWN {
      background: @red;
      color: #fff;

      .fa-circle {
        color: darken(@red, 10%);
      }
    }
  }


  .title {
    position: relative;

    .hostname {
      line-height: 15pt;
      padding: 20px;
    }

    .fa-stack {
      position: absolute;
      top: -45px;
      left: -45px;
    }

    .fa-circle {
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    }
  }


  h1 {
    color: #fff;
    font-size: 90pt;
  }

}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
